import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ModalComponent} from "@app/shared/components";
import {Batch} from "@models/batch.model";
import {TreeModel} from "@components/tree/tree.model";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {TreeAdapter} from "@app/shared/util/tree-adapter.utils";

@Component({
  selector: 'app-rename-cart-modal',
  templateUrl: './rename-cart-modal.component.html',
  styleUrls: ['./rename-cart-modal.component.scss']
})
export class RenameCartModalComponent implements OnChanges {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() tools: any;
    @Input() batch: Batch;
    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() updateCart = new EventEmitter<any>();

    treeDisplayTools: TreeModel[];


    selectedTools: any[];

    cartForm: UntypedFormGroup;
    showValidations = false;
    newBatchSelected = false;


    constructor(private treeAdapter: TreeAdapter) {

        this.cartForm = new UntypedFormGroup({
            'name': new UntypedFormControl('', [<any>Validators.required]),
        });
    }

    open() {
        this.modal.open();
    }

    close() {
        this.cartForm.reset();
        this.newBatchSelected = false;
        this.showValidations = false;
        this.modal.close();
    }

    onCancel() {
        this.showValidations = false;
        this.cancelInfoModal.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tools']) {
            this.treeDisplayTools = this.treeAdapter.adaptToolsToTree(this.tools, 'default');
        }
    }

    get areToolsSelected() {
        return this.treeDisplayTools && this.treeDisplayTools.length > 0;
    }

    updateCartClick() {
        if (this.cartForm.invalid) {
            this.showValidations = true;
            return;
        }

        this.updateCart.emit({tools: this.tools, cart: this.cartForm.get('name').value, batchId: this.batch.id});
    }
}
